import { Helmet } from 'react-helmet'
import { Link } from "react-router-dom"
import flyerNovPair from '../../assets/images/slide-novWine.jpg'
import flyerThanks from '../../assets/images/slide-thanks.jpg'
import flyerDecPair from '../../assets/images/slide-decPair.jpg'
import flyerXmas from '../../assets/images/slide-xmas.jpg'
import flyerCookies from '../../assets/images/slide-cookiesCocoa.png'
import flyerCards from '../../assets/images/slide-giftCardSpecial.jpg'
import pdfXmas from '../../ChristmasDinner.pdf'
import pdfDecPair from '../../DecemberWine.pdf'
import pdfCookies from '../../CookiesAndCocoa.pdf'
import pdfCards from '../../GiftCardSpecial.pdf'

export default function EventList(){
  return (
    <div className="pageStyles eventList">
      <Helmet>
        <title>Delicious Events at Villaggio Grille</title>
        <meta name="description" content="Don't miss these upcoming events and experiences at Villaggio Grille. Your taste buds will thank you!" />
      </Helmet>

      <div className="simpleBanner">
        <div className="sbWrap kpWrapXl">
          <h1>Holiday Season Events &amp; Specials</h1>
          <p className="instr">Select an event from the list below to learn more.</p>
        </div>
      </div>

      <div className="fullSec eventGrid">
        <div className="sectionWrap kpWrapXl">
          <div className="hlf leftSide stickyNn__XX">
            <h3>November</h3>

            {/* <a href={pdfHoliday} target="_blank" rel="noreferrer"><img src={flyerHoliday} alt="Villaggio Holiday Event Schedule" /></a> */}
            <div className="item i5 cookies"><a href={pdfCards} target="_blank" rel="noreferrer"><img src={flyerCards} alt="Villaggio Gift Card Special" /></a></div>
            <div className="item i1 npair"><Link to="/pairing"><img src={flyerNovPair} alt="Villaggio - November Wine Pairing" /></Link></div>
            <div className="item i2 thanks"><Link to="/thanksgiving"><img src={flyerThanks} alt="View Villaggio's Thanksgiving menu" /></Link></div>
          </div>

          <div className="hlf rightSide">
            <h3>December</h3>
            {/* <div className="item i1 npair"><Link to="/pairing"><img src={flyerNovPair} alt="Villaggio - November Wine Pairing" /></Link></div>
            <div className="item i2 thanks"><Link to="/thanksgiving"><img src={flyerThanks} alt="View Villaggio's Thanksgiving menu" /></Link></div> */}
            <div className="item i4 dpair"><a href={pdfDecPair} target="_blank" rel="noreferrer"><img src={flyerDecPair} alt="December Wine Pairing at Villaggio" /></a></div>
            <div className="item i5 xmas"><a href={pdfXmas} target="_blank" rel="noreferrer"><img src={flyerXmas} alt="Villaggio Christmas menu" /></a></div>
            <div className="item i5 cookies"><a href={pdfCookies} target="_blank" rel="noreferrer"><img src={flyerCookies} alt="Villaggio Christmas Cookie Event" /></a></div>
          </div>
          <div className="clearfix"></div>
        </div>
      </div>
      <div className="col-xs-12"><div className="hr hr-png-1"></div></div>
    </div>
  )
}
